import React, { Fragment } from 'react';
import { Mail, Clock, CheckSquare, Slack, Plus, ArrowDown } from 'lucide-react';
interface Step {
  id: string;
  type: 'email' | 'wait' | 'task' | 'slack';
  title: string;
  summary: string;
}
interface StepNavigatorProps {
  steps: Step[];
  selectedStepId: string;
  onSelectStep: (stepId: string) => void;
  onAddStep: () => void;
}
const StepNavigator: React.FC<StepNavigatorProps> = ({
  steps,
  selectedStepId,
  onSelectStep,
  onAddStep
}) => {
  const getStepIcon = (type: string) => {
    switch (type) {
      case 'email':
        return <Mail size={18} className="text-blue-500" data-id="element-319" />;
      case 'wait':
        return <Clock size={18} className="text-gray-500" data-id="element-320" />;
      case 'task':
        return <CheckSquare size={18} className="text-purple-500" data-id="element-321" />;
      case 'slack':
        return <Slack size={18} className="text-[#4A154B]" data-id="element-322" />;
      default:
        return <Mail size={18} data-id="element-323" />;
    }
  };
  return <div className="flex flex-col h-full border-r" data-id="element-324">
      <div className="p-4 border-b" data-id="element-325">
        <h2 className="text-lg font-medium" data-id="element-326">Sequence steps</h2>
      </div>
      <div className="flex-1 overflow-y-auto" data-id="element-327">
        {steps.map((step, index) => <Fragment key={step.id} data-id="element-328">
            <div className={`flex items-start p-4 border-b cursor-pointer hover:bg-gray-50 ${selectedStepId === step.id ? 'bg-blue-50' : ''}`} onClick={() => onSelectStep(step.id)} data-id="element-329">
              <div className="flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full mr-3 shrink-0" data-id="element-330">
                {getStepIcon(step.type)}
              </div>
              <div className="flex-1" data-id="element-331">
                <div className="flex items-center mb-1" data-id="element-332">
                  <span className="text-xs text-gray-500 mr-2" data-id="element-333">
                    Step {index + 1}
                  </span>
                  <span className="text-sm font-medium" data-id="element-334">{step.title}</span>
                </div>
                <p className="text-xs text-gray-600" data-id="element-335">{step.summary}</p>
              </div>
            </div>
            {index < steps.length - 1 && <div className="flex justify-center py-2 border-b" data-id="element-336">
                <ArrowDown size={18} className="text-gray-400" data-id="element-337" />
              </div>}
          </Fragment>)}
        {/* Add Step Button */}
        <div className="flex items-center justify-center p-4 border-b cursor-pointer hover:bg-gray-50" onClick={onAddStep} data-id="element-338">
          <div className="flex items-center gap-2 py-2 px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100" data-id="element-339">
            <Plus size={16} data-id="element-340" />
            <span data-id="element-341">Add a step</span>
          </div>
        </div>
      </div>
    </div>;
};
export default StepNavigator;